export default async function ({ $axios, redirect }) {
  // Intercepta todas as requisições
  $axios.onError((error) => {
    // Verifica se o status da resposta é diferente de 200
    if (error.response && error.response.status !== 200) {
      // Redireciona para a página inicial
      return redirect('/');
    }
  });
} 